'use client'

import { Link } from '@/components/ui/deprecated-link'
import { MainRoutes } from '@/utils/routes'
import { useNavTracking } from './use-nav-tracking'

export function NavSignupButton({ 
  navType 
}: { 
  navType: 'desktop' | 'mobile' 
}) {
  const { trackNavSignupClick } = useNavTracking()

  return (
    <>
      {navType === 'desktop' && (
        <Link 
            href={MainRoutes.SignUp} 
            variant="primaryButton" 
            onClick={() => trackNavSignupClick()}
        >
            Unlock All Salaries
        </Link>
      )}
      {navType === 'mobile' && (
        <Link
            href={MainRoutes.SignUp}
            variant="primaryButton"
            className="w-full font-bold"
            size="lg"
            onClick={() => trackNavSignupClick()}
        >
        Unlock All Salaries
        </Link>
            
      )}
    </>
  )
} 